import React from "react";

import thema from "astrid-config/src/genres/thema_v1.6_sv.json";

import Form from "../../../forms/components/Form/Form";

export default function ArticleMetaDataMainThemaSelect({ name }) {
	const { watch } = Form.useFormContext();

	const themaCodes = watch("themaCodes");

	// qualifiers (codes starting with a digit) can't be the main subject in onix
	const options = (themaCodes || [])
		.filter((code) => !/^\d/.test(code))
		.map((code) => ({
			key: code,
			value: code,
			text: thema[code] ? `${code} - ${thema[code]}` : code,
		}));

	return <Form.Select name={name} options={options} allowEmpty />;
}
